export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11046.4db63484.jpg";